import { defineStore } from 'pinia'
import * as moment from 'moment'

export const useQuickBooking = defineStore('quickBooking', {
  state: () => ({
    user: {
      "email": null,
      "first_name": null,
      "last_name": null,
      "mobile": null,
      "gender": null
    },
    booking: {
      "branch_id": null,
      "start_date_time": null,
      "note": "",
      "category_id": null,
      "employee_id": null,
      "employee_selection_token": null,
      "services": []
    },
    bookingResponse: null,
    errorMessage: null
  }),
  actions: {
    setErrorMessage(message) {
      this.errorMessage = message
    },
    updateUserValues(payload) {
      this.user[payload.key] = payload.value
    },
    updateBookingValues(payload) {
      this.booking[payload.key] = payload.value
    },
    updateBookingEmployeeValues(payload) {
      this.booking['services'].forEach((service) => {
        service.employee_id = payload
      })
    },
    // Assigns sequential, back-to-back start times to each selected service
    // (service[1] starts when service[0] ends, and so on), matching the
    // admin booking form's multi-procedure scheduling behaviour.
    updateBookingServiceTimeValues(payload) {
      let cursor = payload ? moment(payload) : null
      this.booking['services'].forEach((service) => {
        if (!cursor) {
          service.start_date_time = null
          return
        }
        service.start_date_time = cursor.format('YYYY-MM-DD HH:mm:ss')
        cursor = cursor.clone().add(Number(service.duration_min) || 0, 'minutes')
      })
    },
    updateBookingResponse(payload) {
      this.bookingResponse = payload
      this.errorMessage = null
    },
    resetState() {
      this.bookingResponse = null
      this.errorMessage = null
      this.booking = {
        "branch_id": null,
        "start_date_time": null,
        "note": "",
        "category_id": null,
        "employee_id": null,
        "employee_selection_token": null,
        "services": []
      }
      this.user = {
        "email": null,
        "first_name": null,
        "last_name": null,
        "mobile": null,
        "gender": null
      }
    }
  }
})
